import {BaseTerms} from "../../../../infrastructure/models/base-terms";

export class FooterModuleTerms extends BaseTerms {
  FOOTER_INSTAGRAM_TITLE = "Follow 365Scores News, Stories and Updates on Instagram";
  FOOTER_FACEBOOK_TITLE = "Follow 365Scores News, Stories and Updates on Facebook";
  FOOTER_TWITTER_TITLE = "Follow 365Scores News and Updates on Twitter";
  FOOTER_INSTALL_APPLE_TITLE = "Get the 365Scores app on the AppStoe - Live Scores & Sports News";
  FOOTER_INSTALL_GOOGLE_TITLE = "Get the 365Scores app on Google Play - Live Scores & Sports News";
  FOOTER_INSTAGRAM_ALT = "365Scores on Instagram\"";
  FOOTER_FACEBOOK_ALT = "365Scores on Facebook";
  FOOTER_TWITTER_ALT = "365Scores on Twitter";
  FOOTER_INSTALL_APPLE_ALT = "365Scores app on the AppStore";
  FOOTER_INSTALL_GOOGLE_ALT = "365Scores app on Google Play";
  GET_COMPLETE_MOBILE_EXPERIENCE = "Get the complete mobile experience";
  FOLLOW_TW_FOLLOW_BUTTON = "Follow Us";
  FOOTER_COPYRIGHT = "Copyright ©2012-18 365scores.com / All rights reserved";
  VERSION_NO_KEY = "ver";
  FOOTER_DESCRIPTION = "365Scores Footer Description";
  FOOTER_ABOUT = "About";
  FOOTER_ADVERTIZE = "Advertise";
  FOOTER_JOBS = "Jobs";
  FOOTER_BLOG = "Blog";
  FOOTER_CONTACT = "Contact Us";
  ABOUT_PUBLISHERS_FOOTER = "Publishers";
  FOOTER_MATCH_TEST = "Saudi Arabia U23 VS Brazil U23";
  FOOTER_TERMS = "Terms of Use";
  GAME_TEST_EN = "Tottenham VS Manchester city";
}
